import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconPauseCircleComponent } from "./med-icon-pause-circle.component";

@NgModule({
  declarations: [
    MedIconPauseCircleComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconPauseCircleComponent,
  ],
})
export class MedIconPauseCircleModule { }
